import dayjs from 'dayjs'
// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// dayjs.extend(isSameOrBefore)
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

export default dayjs